import { useState } from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ onFilterChange, isMobile, onClose }) => {
  const [discountRange, setDiscountRange] = useState('');
  const [rating, setRating] = useState('');
  const [sortBy, setSortBy] = useState('relevance');

  const discountRanges = [
    { value: '', label: 'Todos los descuentos' },
    { value: '0-10', label: '0% - 10%' },
    { value: '10-20', label: '10% - 20%' },
    { value: '20-30', label: '20% - 30%' },
    { value: '30-50', label: '30% - 50%' },
    { value: '50+', label: 'Más de 50%' }
  ];

  const ratings = [
    { value: '', label: 'Todas las calificaciones' },
    { value: '4', label: '4+ estrellas' },
    { value: '3', label: '3+ estrellas' },
    { value: '2', label: '2+ estrellas' }
  ];

  const sortOptions = [
    { value: 'relevance', label: 'Más relevantes' },
    { value: 'discount-high', label: 'Mayor descuento' },
    { value: 'discount-low', label: 'Menor descuento' },
    { value: 'rating', label: 'Mejor calificados' },
    { value: 'newest', label: 'Más recientes' },
    { value: 'proximity', label: 'Más cercanos' }
  ];

  const handleApplyFilters = () => {
    onFilterChange({ discountRange, rating, sortBy });
    if (isMobile && onClose) {
      onClose();
    }
  };

  const handleResetFilters = () => {
    setDiscountRange('');
    setRating('');
    setSortBy('relevance');
    onFilterChange({ discountRange: '', rating: '', sortBy: 'relevance' });
  };

  const content = (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={16} />
          Filtros Avanzados
        </h3>
      </div>

      <Select
        label="Rango de descuento"
        options={discountRanges}
        value={discountRange}
        onChange={setDiscountRange}
      />

      <Select
        label="Calificación mínima"
        options={ratings}
        value={rating}
        onChange={setRating}
      />

      <Select
        label="Ordenar por"
        options={sortOptions}
        value={sortBy}
        onChange={setSortBy}
      />

      <div className="flex gap-2 pt-2">
        <Button
          variant="default"
          onClick={handleApplyFilters}
          iconName="Check"
          iconPosition="left"
          fullWidth
        >
          Aplicar
        </Button>
        <Button
          variant="outline"
          onClick={handleResetFilters}
          iconName="RotateCcw"
          size="icon"
        >
          <span className="sr-only">Restablecer filtros</span>
        </Button>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <div className="fixed inset-0 bg-black/50 z-[1050]" onClick={onClose}>
        <div
          className="fixed bottom-0 left-0 right-0 bg-card rounded-t-2xl p-6 z-[1100] max-h-[80vh] overflow-y-auto"
          onClick={(e) => e?.stopPropagation()}
        >
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-foreground">Filtros</h2>
            <button onClick={onClose} aria-label="Cerrar filtros">
              <Icon name="X" size={24} />
            </button>
          </div>
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg p-6 shadow-card sticky top-24">
      {content}
    </div>
  );
};

export default FilterPanel;